import { createSlice } from "@reduxjs/toolkit";

const initialState = localStorage.getItem("categoryWord")
  ? JSON.parse(localStorage.getItem("categoryWord"))
  : {
      categoryWord: [],
    };

const categoryWord = createSlice({
  name: "categoryWord",
  initialState,
  reducers: {
    updateCategoryWord: (state, action) => {
      state.categoryWord = [...state.categoryWord, action.payload];
      localStorage.setItem("categoryWord", JSON.stringify(state));
      return state;
    },
    deleteCategoryWord:(state,action)=>{
        state.categoryWord.pop(); 
        localStorage.setItem("categoryWord", JSON.stringify(state));
        return state;
    },
    resetCategoryWord: (state, action) => {
      state.categoryWord = [];
      localStorage.removeItem("categoryWord");
      return state;
    },
  },
});

export const { updateCategoryWord, deleteCategoryWord,resetCategoryWord } = categoryWord.actions;
export default categoryWord;
